export default __webpack_public_path__ + "static/media/bathroom.76e33896.png";